   <div class="container-fluid p-0">
      <div class="row bg-white py-4 no-gutters">
         <div class="col-12">
            <custom-header></custom-header>
         </div>
      </div>
      <div class="row no-gutters header-row-bg">
         <div class="col-12"></div>
      </div>
      <div class="row no-gutters">
         <div class="col-12 parent_viewport">
            <div class="container-md px-0 px-md-3 ">
               <div class="row no-gutters">
                  <div  [ngClass]="(isSidebarVisible&&!isSummaryPage)?'col-12 mainCard':'col-12 mainCard'">
                     <div class="row no-gutters" role="main">
                        <div [ngClass]="(isSidebarVisible&&!isSummaryPage)?'sideBarLine sideRightPadding top_spa_aft_mobile_sect_heading  col-md-4 col-12':''">
                           <sidebar *ngIf="isSidebarVisible&& !isSummaryPage"></sidebar>
                        </div>
                        <div  [ngClass]="(isSidebarVisible&&!isSummaryPage)?'col-md-8 col-12 mobileViewPadding mainCardLeftPadding':'col-12 mainCardLeftPaddingSummary mobileViewPaddingSummary'">
                           <router-outlet></router-outlet>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <div class="row no-gutters py-4 footer_bg mt-md-4 mt-0 content_top_mobile_margin">
         <div class="col-12">
               <custom-footer></custom-footer>
         </div>
      </div>
   </div>
